module.exports = __webpack_public_path__ + "img/group_icon.0deb5c5f.svg";